module.exports = __webpack_public_path__ + "static/shizaru-35f92e4ce54a34d746c3b77f20ce3b30.png";